export default __webpack_public_path__ + "static/no-meals-798c3d82a2ea754d21b2bf538a965a71.png";